<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\vi\newManual\convenantManual-1.png" alt="" /></div>
                <div>
                    <p>① Nếu đỗ Kì thi cuối kỳ thì % tiến độ sẽ tăng lên. Nhấn vào nút [Bản cam kết] trên thanh menu con, thì màn hình Bản cam kết sẽ được hiển thị.</p>
                </div>
                <div><img src="/static\images\vi\newManual\convenantManual-2.png" alt="" /></div>
                <div>
                    <p>② Đánh dấu check vào ô đồng ý của màn hình Bản cam kết.</p>
                    <p>③ Nhấn nút [Gửi đi] để nộp Bản cam kết.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/covenant_manual.vue